import { mapFromAIEntityInstruction } from 'mappings/aiEntityInstructionMapping';
import {
  CopilotExternalDocumentInstructionEdit,
  CopilotExternalDocumentInstructionEditRequest,
} from 'models/copilot/copilotExternalDocumentInstructionEdit';
import {
  CopilotExternalDocumentInstructionEditDTO,
  CopilotExternalDocumentInstructionEditRequestDTO,
} from 'models/dto/copilot/copilotExternalDocumentInstructionEditDTO';

export function mapToCopilotExternalDocumentInstructionEditRequest(
  item: CopilotExternalDocumentInstructionEditRequest,
): CopilotExternalDocumentInstructionEditRequestDTO {
  const dto = new CopilotExternalDocumentInstructionEditRequestDTO();
  dto.externalId = item.externalId;

  return dto;
}

export function mapFromCopilotExternalDocumentInstructionEdit(
  item: CopilotExternalDocumentInstructionEditDTO,
): CopilotExternalDocumentInstructionEdit {
  const output = new CopilotExternalDocumentInstructionEdit();
  output.externalId = item.externalId ?? '';
  output.libraryLinkId = item.libraryLinkId ?? 0;
  output.libraryListId = item.libraryListId ?? 0;
  output.title = item.title;
  output.pendingInstruction = item.pendingInstruction ?? '';
  output.instruction = item.instruction ? mapFromAIEntityInstruction(item.instruction) : undefined;

  return output;
}
